import * as DatasetHelper from '../dataset-helper';

/**
 * Calculate the mean for the data.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
  const categories = categoryField.categories;
  const numOfCategories = categories.length;
  const propertyName = calculationStepDefn.propertyName;
  const resultPropertyName = calculationStepDefn.result;

  // Calculate mean.
  let accumulator = 0.0;
  categories.forEach(category => {
    const categoryResult = statistics[category.value];
    const value = categoryResult[propertyName] || 0.0;
    accumulator = accumulator + value;
  });
  const mean = (numOfCategories > 0 ? accumulator / numOfCategories : 0);
  statistics[resultPropertyName] = mean;

}




// WEBPACK FOOTER //
// ./src/app/utils/calculators/mean-calculator.js